<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="entryTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Lançamento</th>
    <td mat-cell *matCellDef="let element">
      {{ element.entryTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolio.document }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolio.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="bank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolio.bank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="branch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolio.branch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="account">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolio.account }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioClearingAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta CETIP</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolio.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="cetipSettlement">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.cetipSettlement ? "CETIP" : "" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="baseValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.baseValue }}
    </td>
  </ng-container>

  <ng-container matColumnDef="contractNumber">
    <th mat-header-cell class="header" *matHeaderCellDef>Número do Contrato</th>
    <td mat-cell *matCellDef="let element">
      {{ element.contractNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="futureFee">
    <th mat-header-cell class="header" *matHeaderCellDef>Taxa Termo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.futureFee }}
    </td>
  </ng-container>

  <ng-container matColumnDef="quoteExpirationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Cotação no Vencimento
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.quoteExpirationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="currencyId">
    <th mat-header-cell class="header" *matHeaderCellDef>Moeda</th>
    <td mat-cell *matCellDef="let element">
      {{ element.currencyId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="crossRate">
    <th mat-header-cell class="header" *matHeaderCellDef>Cross Rate</th>
    <td mat-cell *matCellDef="let element">
      {{ element.crossRate ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expirationDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Vencimento</th>
    <td mat-cell *matCellDef="let element">
      {{ element.expirationDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="financialValue">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Valor Financeiro em Reais
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.financialValue | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="interestFee">
    <th mat-header-cell class="header" *matHeaderCellDef>Taxa Juros</th>
    <td mat-cell *matCellDef="let element">
      {{ element.interestFee }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewCounterpart">
    <th mat-header-cell class="header" *matHeaderCellDef>
      É Nova Contraparte?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewCounterpart ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpart.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpart.document }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartClearingAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Conta CETIP da Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpart.clearingAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsCurrencyTerm.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsCurrencyTerm"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsCurrencyTerm"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
